import React from "react";

export default function WhyKryptogram() {
  return (
    <>
      <div
        className="tp-service-area pt-180 pb-80 tp-btn-trigger"
        style={{
          // backgroundPosition: "50% 50%",
          backgroundSize: "cover",
          backgroundImage: "url(assets/img/one/shape-bg.png)",
        }}
      >
        <div className="container container-1530">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="tp-service-title-box p-relative">
                <h4 className="tp-section-title tp-char-animation">
                  Why Kryptogram?
                </h4>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="tp-service-right-wrap">
                <div className="tp-service-item d-flex align-items-start mb-40 tp_fade_bottom">
                  <div className="tp-service-icon">
                    <img
                      src="assets/img/home-01/service/service-icon-1.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm order-0">
                      <a>Real-World Land Meets Digital Assets</a>
                    </h4>
                    <p className="order-1">
                      The perfect fusion of &nbsp;
                      <span className="bold-text">
                        Blockchain Ownership And Physical Real Estate.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-40 tp_fade_bottom">
                  <div className="tp-service-icon">
                    <img
                      src="assets/img/home-01/service/service-icon-2.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm">
                      <a> More Than Just an NFT</a>
                    </h4>
                    <p>
                      Gain exclusive access to a &nbsp;
                      <span className="bold-text">
                        world-class blockchain event
                      </span>
                      &nbsp; and elite networking opportunities.
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-40 tp_fade_bottom">
                  <div className="tp-service-icon">
                    <img
                      src="assets/img/home-01/service/service-icon-3.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm">
                      <a>Profitable Long-Term Investment</a>
                    </h4>
                    <p>
                      Limited Supply Means&nbsp;
                      <span className="bold-text">
                        Scarcity-Driven Appreciation
                      </span>
                      &nbsp; And &nbsp;
                      <span className="bold-text">Future Staking Rewards.</span>
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-40 tp_fade_bottom">
                  <div className="tp-service-icon">
                    <img
                      src="assets/img/home-01/service/service-icon-4.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm">
                      <a>Join The Future Today!</a>
                    </h4>
                    <p>
                      Be A Part Of &nbsp;
                      <span className="bold-text">
                        history’s First Blockchain-Backed Land Ownership
                        Festival Project.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
